import React from 'react'

import CustomTable from '../../CommonComponents/CustomTableComponent'

const ExcludeProductTable = ({ products, negativeTargetings, onSearch, onChange }) => {
  const handleExclude = (product) => {
    const duplicate = negativeTargetings.filter(target => target.type === 'product')
      .find(target => target.asin === product.asin)

    if (duplicate) {
      return
    }

    onChange([
      {
        ...product,
        isTargeted: true,
        type: 'product',
      },
      ...negativeTargetings,
    ])
  }

  const renderProduct = product => (
    <>
      <div className="table-col col-product">
        <img src={product.image} alt={product.name} />
        <div className="product-info">
          <div className="product-name" title={product.name}>
            { product.name }
          </div>
          <div className="product-asin-info">
            ASIN: { product.asin }
          </div>
        </div>
      </div>
      <div className="table-col">
        {
          product.isTargeted ? (
            <button type="button" className="btn btn-blue disabled">Excluded</button>
          ) : (
            <button type="button" className="btn btn-blue" onClick={() => { handleExclude(product) }}>
              Exclude
            </button>
          )
        }
      </div>
    </>
  )

  return (
    <CustomTable
      className="table-products"
      records={products}
      noCheckBox
      idField="asin"
      searchFields={['name', 'asin']}
      searchPlaceholder="Find ASINs"
      renderRecord={renderProduct}
      onSearch={onSearch}
    >
      <div className="table-col col-product">Product</div>
      <div className="table-col">
      </div>
    </CustomTable>
  )
}

export default ExcludeProductTable
